import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import type {SliderOptionsRange} from '@Components/slider-options';
import {BleedUnit} from '@PosterWhiteboard/poster/bleed.class';
import {useAppSelector} from '@/hooks';

const BLEED_INCHES_MIN_VALUE = 0;
const BLEED_MILLIMETER_MIN_VALUE = 0;
const BLEED_INCHES_MAX_VALUE = 3;
const BLEED_MILLIMETER_MAX_VALUE = 50;
const BLEED_PRECISION = 0.01;
const BLEED_STEP = 0.1;

export function PageBleedUnitSizeOption(): ReactElement<any> | null {
  const bleedVal = useAppSelector((state) => {
    return state.posterEditor.posterObject?.bleed.val;
  });
  const bleedUnits = useAppSelector((state) => {
    return state.posterEditor.posterObject?.bleed.unit;
  });

  if (bleedVal === undefined || bleedUnits === undefined) {
    return null;
  }

  const getRangeObjectForInches = (): SliderOptionsRange => {
    return {
      min: BLEED_INCHES_MIN_VALUE,
      max: BLEED_INCHES_MAX_VALUE,
    };
  };

  const getRangeObjectForMillimeter = (): SliderOptionsRange => {
    return {
      min: BLEED_MILLIMETER_MIN_VALUE,
      max: BLEED_MILLIMETER_MAX_VALUE,
    };
  };

  const getRangeObject = (): SliderOptionsRange => {
    switch (bleedUnits) {
      case BleedUnit.INCHES:
        return getRangeObjectForInches();
      case BleedUnit.MILLI_METER:
        return getRangeObjectForMillimeter();
      default:
        throw new Error('unhandled bleed unit');
    }
  };

  const onChangeHandlerForBleedValue = (updatedValue: number): void => {
    void window.posterEditor?.whiteboard?.updateFromObject(
      {
        bleed: {
          val: updatedValue,
        },
      },
      {
        undoable: false,
      }
    );
  };

  const getBleedValueInputField = (): ReactElement<any> => {
    return (
      <ContextualMenuSliderOptions
        id="bleed-unit-input-option"
        value={bleedVal}
        label={window.i18next.t('pmwjs_value')}
        range={getRangeObject()}
        transformDisplay={getRangeObject()}
        step={BLEED_STEP}
        minimumStepFromInputField={BLEED_PRECISION}
        precision={BLEED_PRECISION}
        onChange={onChangeHandlerForBleedValue}
      />
    );
  };
  return getBleedValueInputField();
}
